var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header-bar"},[_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('div',{staticClass:"logo"},[_vm._v(" Nude på "),_c('br'),_vm._v(" nätet ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }